import { render, staticRenderFns } from "./accountRelating.vue?vue&type=template&id=0079c386&scoped=true&"
import script from "./accountRelating.vue?vue&type=script&scoped=true&lang=js&"
export * from "./accountRelating.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./accountRelating.vue?vue&type=style&index=0&id=0079c386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079c386",
  null
  
)

export default component.exports